import React, { useState } from 'react';
import './settings.css';

function Settings() {
  const [activeTab, setActiveTab] = useState('general');
  
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };
  
  return (
    <div className="OCRP-settings">
      {/* Tabs navigation */}
      <div className="OCRP-analysis-tabs">
        <button 
          className={`OCRP-tab-button ${activeTab === 'general' ? 'OCRP-tab-active' : ''}`}
          onClick={() => handleTabChange('general')}
        >
          <i className="fas fa-cog"></i>
          <span>General</span>
        </button>

      </div>
      
      <div className="OCRP-settings-content">
        {activeTab === 'general' && (
          <div className="OCRP-settings-section">
            <h2>General Settings</h2>
            <div className="OCRP-settings-form">
              <div className="OCRP-form-group">
                <label>Application Theme</label>
                <select className="OCRP-select">
                  <option value="dark">Dark (Default)</option>
                  <option value="light">Light</option>
                  <option value="system">System Preference</option>
                </select>
              </div>
              
              <div className="OCRP-form-group">
                <label>Default Language</label>
                <select className="OCRP-select">
                  <option value="en">English</option>
                  <option value="fr">Français</option>
                  <option value="de">Deutsch</option>
                  <option value="es">Español</option>
                </select>
              </div>
              
              <div className="OCRP-form-group">
                <label>Data Refresh Interval</label>
                <select className="OCRP-select">
                  <option value="5">5 minutes</option>
                  <option value="15">15 minutes</option>
                  <option value="30">30 minutes</option>
                  <option value="60">1 hour</option>
                </select>
              </div>
              
              <div className="OCRP-form-group">
                <label>Notifications</label>
                <div className="OCRP-toggle-group">
                  <div className="OCRP-toggle-item">
                    <input type="checkbox" id="notify-updates" className="OCRP-checkbox" checked />
                    <label htmlFor="notify-updates">Database Updates</label>
                  </div>
                  <div className="OCRP-toggle-item">
                    <input type="checkbox" id="notify-reports" className="OCRP-checkbox" checked />
                    <label htmlFor="notify-reports">Report Generation</label>
                  </div>
                  <div className="OCRP-toggle-item">
                    <input type="checkbox" id="notify-system" className="OCRP-checkbox" checked />
                    <label htmlFor="notify-system">System Notifications</label>
                  </div>
                </div>
              </div>
              
              <div className="OCRP-button-row">
                <button className="OCRP-button OCRP-button-primary">Save Changes</button>
                <button className="OCRP-button OCRP-button-secondary">Reset to Defaults</button>
              </div>
            </div>
          </div>
        )}
        
        {activeTab === 'api' && (
          <div className="OCRP-settings-section">
            <h2>API Connections</h2>
            <div className="OCRP-settings-form">
              <div className="OCRP-form-group">
                <label>Default API Endpoint</label>
                <input type="text" className="OCRP-input" value="https://api.szapfs.org/oncorisk/v2" />
              </div>
              
              <div className="OCRP-form-group">
                <label>API Authentication</label>
                <select className="OCRP-select">
                  <option value="token">Bearer Token</option>
                  <option value="oauth">OAuth 2.0</option>
                  <option value="key">API Key</option>
                </select>
              </div>
              
              <div className="OCRP-form-group">
                <label>API Key / Token</label>
                <div className="OCRP-input-with-button">
                  <input type="password" className="OCRP-input" value="••••••••••••••••••••••••••" />
                  <button className="OCRP-input-button">
                    <i className="fas fa-eye"></i>
                  </button>
                </div>
              </div>
              
              <div className="OCRP-form-group">
                <label>External Integrations</label>
                <div className="OCRP-toggle-group">
                  <div className="OCRP-toggle-item">
                    <input type="checkbox" id="integrate-cbioportal" className="OCRP-checkbox" checked />
                    <label htmlFor="integrate-cbioportal">cBioPortal</label>
                  </div>
                  <div className="OCRP-toggle-item">
                    <input type="checkbox" id="integrate-oncokb" className="OCRP-checkbox" checked />
                    <label htmlFor="integrate-oncokb">OncoKB</label>
                  </div>
                  <div className="OCRP-toggle-item">
                    <input type="checkbox" id="integrate-civic" className="OCRP-checkbox" checked />
                    <label htmlFor="integrate-civic">CIViC</label>
                  </div>
                </div>
              </div>
              
              <div className="OCRP-button-row">
                <button className="OCRP-button OCRP-button-primary">Save Changes</button>
                <button className="OCRP-button OCRP-button-secondary">Test Connection</button>
              </div>
            </div>
          </div>
        )}
        
        {activeTab === 'users' && (
          <div className="OCRP-settings-section">
            <h2>User Access Management</h2>
            <div className="OCRP-settings-form">
              <div className="OCRP-form-group">
                <label>Access Control Mode</label>
                <select className="OCRP-select">
                  <option value="rbac">Role-Based Access Control</option>
                  <option value="abac">Attribute-Based Access Control</option>
                </select>
              </div>
              
              <div className="OCRP-table-container">
                <h3>Active Users</h3>
                <table className="OCRP-table">
                  <thead>
                    <tr>
                      <th>User</th>
                      <th>Role</th>
                      <th>Last Access</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>admin@szapfs.org</td>
                      <td>Administrator</td>
                      <td>2025-05-30 18:45</td>
                      <td><span className="OCRP-status-active">Active</span></td>
                      <td>
                        <button className="OCRP-icon-button">
                          <i className="fas fa-edit"></i>
                        </button>
                        <button className="OCRP-icon-button">
                          <i className="fas fa-key"></i>
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td>user1@szapfs.org</td>
                      <td>Analyst</td>
                      <td>2025-05-29 14:20</td>
                      <td><span className="OCRP-status-active">Active</span></td>
                      <td>
                        <button className="OCRP-icon-button">
                          <i className="fas fa-edit"></i>
                        </button>
                        <button className="OCRP-icon-button">
                          <i className="fas fa-key"></i>
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td>user2@szapfs.org</td>
                      <td>Viewer</td>
                      <td>2025-05-28 09:15</td>
                      <td><span className="OCRP-status-inactive">Inactive</span></td>
                      <td>
                        <button className="OCRP-icon-button">
                          <i className="fas fa-edit"></i>
                        </button>
                        <button className="OCRP-icon-button">
                          <i className="fas fa-key"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              
              <div className="OCRP-button-row">
                <button className="OCRP-button OCRP-button-primary">
                  <i className="fas fa-user-plus"></i>
                  Add New User
                </button>
                <button className="OCRP-button OCRP-button-secondary">
                  <i className="fas fa-sync"></i>
                  Refresh
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Settings;
